export default "__VITE_ASSET__C5Z6mSjM__"